import { render, staticRenderFns } from "./SubMenuLayout.vue?vue&type=template&id=3c876b07&scoped=true&"
import script from "./SubMenuLayout.vue?vue&type=script&lang=js&"
export * from "./SubMenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuLayout.vue?vue&type=style&index=0&id=3c876b07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c876b07",
  null
  
)

export default component.exports